export enum FileAction {
  CopyFilename = 'copy-filename',
  CopyModality = 'copy-modality',
  Delete = 'delete',
  VersionHistory = 'version-history',
  Download = 'download',
  Information = 'info',
  View = 'view',
  Cvat = 'cvat',
  Tasks = 'tasks',
}

export enum FileOriginAction {
  Copied = 'copied',
  Created = 'created',
  Replaced = 'replaced',
  Restored = 'restored',
}
